import { Row, Col, Card, Typography, Layout, theme } from "antd";
import { Link } from "react-router-dom";
import { FileTextOutlined } from "@ant-design/icons";
import { HeaderApp, NavigationBar } from "../../shared";
import { Handshake, Users, Tags, Package, FolderTree } from "lucide-react";

const DashboardCatalogs = () => {
	const { token } = theme.useToken();
	return (
		<>
			<HeaderApp sectionName="Catálogos" showBack />
			<Layout.Content style={{ padding: "16px" }} className="max-width-container">
				<Row gutter={[12, 12]}>
					<Col xs={24} sm={12} >
						<Card
							size="small"
							hoverable
							style={{ borderRadius: "12px", cursor: "pointer" }}
							bodyStyle={{ padding: "16px" }}
						>
							<Link to={"/catalogo/proveedores"}>
								<div
									style={{
										display: "flex",
										flexDirection: "column",
										gap: "12px",
										width: "150px",

									}}
								>
									<div
										style={{
											display: "flex",
											alignItems: "center",
											justifyContent: "center",
											width: "40px",
											height: "40px",
											borderRadius: "8px",
											backgroundColor: token.colorPrimaryBg,
											color: token.colorPrimary,
										}}
									>
										<Handshake size={24} />
									</div>
									<div>
										<Typography.Text strong style={{ fontSize: "14px" }}>
											Proveedores
										</Typography.Text>
										<br />
										<Typography.Text
											style={{ fontSize: "10px", color: token.colorTextSecondary }}
										>
											Gestionar proveedores
										</Typography.Text>
									</div>
								</div>
							</Link>
						</Card>
					</Col>
					<Col xs={24} sm={12} >
						<Card
							size="small"
							hoverable
							style={{ borderRadius: "12px", cursor: "pointer" }}
							bodyStyle={{ padding: "16px" }}
						>
							<Link to={"/catalogo/clientes"}>
								<div
									style={{
										display: "flex",
										flexDirection: "column",
										gap: "12px",
										width: "150px",

									}}
								>
									<div
										style={{
											display: "flex",
											alignItems: "center",
											justifyContent: "center",
											width: "40px",
											height: "40px",
											borderRadius: "8px",
											backgroundColor: token.colorPrimaryBg,
											color: token.colorPrimary,
										}}
									>
										<Users size={24} />
									</div>
									<div>
										<Typography.Text strong style={{ fontSize: "14px" }}>
											Clientes
										</Typography.Text>
										<br />
										<Typography.Text
											style={{ fontSize: "10px", color: token.colorTextSecondary }}
										>
											Gestionar clientes
										</Typography.Text>
									</div>
								</div>
							</Link>
						</Card>
					</Col>
					<Col xs={24} sm={12} >
						<Card
							size="small"
							hoverable
							style={{ borderRadius: "12px", cursor: "pointer" }}
							bodyStyle={{ padding: "16px" }}
						>
							<Link to={"/catalogo/conceptos"}>
								<div
									style={{
										display: "flex",
										flexDirection: "column",
										gap: "12px",
										width: "150px",

									}}
								>
									<div
										style={{
											display: "flex",
											alignItems: "center",
											justifyContent: "center",
											width: "40px",
											height: "40px",
											borderRadius: "8px",
											backgroundColor: token.colorPrimaryBg,
											color: token.colorPrimary,
										}}
									>
										<Tags size={24} />
									</div>
									<div>
										<Typography.Text strong style={{ fontSize: "14px" }}>
											Conceptos
										</Typography.Text>
										<br />
										<Typography.Text
											style={{ fontSize: "10px", color: token.colorTextSecondary }}
										>
											Gestionar conceptos
										</Typography.Text>
									</div>
								</div>
							</Link>
						</Card>
					</Col>
					<Col xs={24} sm={12}>
						<Card
							size="small"
							hoverable
							style={{ borderRadius: "12px", cursor: "pointer" }}
							bodyStyle={{ padding: "16px" }}
						>
							<Link to={"/catalogo/productos"}>
								<div
									style={{
										display: "flex",
										flexDirection: "column",
										gap: "12px",
										width: "150px",

									}}
								>
									<div
										style={{
											display: "flex",
											alignItems: "center",
											justifyContent: "center",
											width: "40px",
											height: "40px",
											borderRadius: "8px",
											backgroundColor: token.colorPrimaryBg,
											color: token.colorPrimary,
										}}
									>
										<Package size={24} />
									</div>
									<div>
										<Typography.Text strong style={{ fontSize: "14px" }}>
											Productos
										</Typography.Text>
										<br />
										<Typography.Text
											style={{ fontSize: "10px", color: token.colorTextSecondary }}
										>
											Gestionar productos
										</Typography.Text>
									</div>
								</div>
							</Link>
						</Card>
					</Col>
					<Col xs={24} sm={12}>
						<Card
							size="small"
							hoverable
							style={{ borderRadius: "12px", cursor: "pointer" }}
							bodyStyle={{ padding: "16px" }}
						>
							<Link to={"/catalogo/plan_cuentas"}>
								<div
									style={{
										display: "flex",
										flexDirection: "column",
										gap: "12px",
										width: "150px",
									}}
								>
									<div
										style={{
											display: "flex",
											alignItems: "center",
											justifyContent: "center",
											width: "40px",
											height: "40px",
											borderRadius: "8px",
											backgroundColor: token.colorPrimaryBg,
											color: token.colorPrimary,
										}}
									>
										<FolderTree size={24} />
									</div>
									<div>
										<Typography.Text strong style={{ fontSize: "14px" }}>
											Plan de Cuentas
										</Typography.Text>
										<br />
										<Typography.Text
											style={{ fontSize: "10px", color: token.colorTextSecondary }}
										>
											Gestionar plan de cuentas
										</Typography.Text>
									</div>
								</div>
							</Link>
						</Card>
					</Col>
					<Col xs={24} sm={12}>
						<Card
							size="small"
							hoverable
							style={{ borderRadius: "12px", cursor: "pointer" }}
							bodyStyle={{ padding: "16px" }}
						>
							<div
								className="disabled"
								style={{
									display: "flex",
									flexDirection: "column",
									gap: "12px",
									width: "150px",
								}}
							>
								<div
									style={{
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
										width: "40px",
										height: "40px",
										borderRadius: "8px",
										backgroundColor: token.colorSuccessBg,
										color: token.colorSuccess,
									}}
								>
									<FileTextOutlined style={{ fontSize: "24px" }} />
								</div>
								<div>
									<Typography.Text strong style={{ fontSize: "14px" }}>
										Tipos contratos
									</Typography.Text>
									<br />
									<Typography.Text
										style={{ fontSize: "10px", color: token.colorTextSecondary }}
									>
										Gestionar tipos de contratos
									</Typography.Text>
								</div>
							</div>
						</Card>
					</Col>
					{/* <Col xs={12}>
                        <Card
                            size="small"
                            hoverable
                            style={{ borderRadius: "12px", cursor: "pointer" }}
                            bodyStyle={{ padding: "16px" }}
                        >
                            <Link to={"/contratos"}>
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "12px",
                                    }}
                                >
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            width: "40px",
                                            height: "40px",
                                            borderRadius: "8px",
                                            backgroundColor: "#fed7aa",
                                            color: "#ea580c",
                                        }}
                                    >
                                        <FileDoneOutlined style={{ fontSize: "24px" }} />
                                    </div>
                                    <div>
                                        <Typography.Text strong style={{ fontSize: "14px" }}>
                                            Contratos
                                        </Typography.Text>
                                        <br />
                                        <Typography.Text
                                            style={{ fontSize: "10px", color: "#617589" }}
                                        >
                                            Revisar firmas
                                        </Typography.Text>
                                    </div>
                                </div>
                            </Link>
                        </Card>
                    </Col> */}
					{/* <Col xs={12}>
                        <Card
                            size="small"
                            hoverable
                            style={{ borderRadius: "12px", cursor: "pointer" }}
                            bodyStyle={{ padding: "16px" }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "12px",
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        width: "40px",
                                        height: "40px",
                                        borderRadius: "8px",
                                        backgroundColor: "#e9d5ff",
                                        color: "#a855f7",
                                    }}
                                >
                                    <ShoppingCartOutlined style={{ fontSize: "24px" }} />
                                </div>
                                <div>
                                    <Typography.Text strong style={{ fontSize: "14px" }}>
                                        Ordenes
                                    </Typography.Text>
                                    <br />
                                    <Typography.Text
                                        style={{ fontSize: "10px", color: "#617589" }}
                                    >
                                        Seguimiento
                                    </Typography.Text>
                                </div>
                            </div>
                        </Card>
                    </Col> */}

				</Row>
				<NavigationBar activeKey="/" />
			</Layout.Content>
		</>
	);
};

export default DashboardCatalogs;